import { Typography } from '@mui/material';

export default function FlowChartHowItWorkStepContent({
  content,
  ...otherProps
}) {
  return (
    <Typography variant="body1" {...otherProps}>
      {content}
    </Typography>
  );
}
